(function() {
  'use strict';

  const ExternalCheckout = {
    checkoutUrl: 'https://checkout.whoopsband.com',
    cookieName: 'cart_data',
    
    init: function() {
      this.observeDrawer();
    },

    observeDrawer: function() {
      const self = this;
      
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length) {
            const checkoutBtn = document.querySelector('[data-external-checkout]');
            if (checkoutBtn && !checkoutBtn.hasAttribute('data-checkout-bound')) {
              self.bindCheckoutButton(checkoutBtn);
            }
          }
        });
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      const existingBtn = document.querySelector('[data-external-checkout]');
      if (existingBtn && !existingBtn.hasAttribute('data-checkout-bound')) {
        this.bindCheckoutButton(existingBtn);
      }
    },

    getCartJsonUrl: function() {
      return window.location.origin + '/cart.json';
    },

    sanitizeCartData: function(cart) {
      if (!cart) return null;

      const sanitizeValue = function(val) {
        if (val === null || val === undefined) return '';
        return val;
      };

      const sanitizeItem = function(item) {
        return {
          id: sanitizeValue(item.id),
          quantity: sanitizeValue(item.quantity) || 0,
          title: sanitizeValue(item.title) || 'Product',
          price: sanitizeValue(item.price) || 0,
          line_price: sanitizeValue(item.line_price) || 0,
          final_price: sanitizeValue(item.final_price) || 0,
          final_line_price: sanitizeValue(item.final_line_price) || 0,
          sku: sanitizeValue(item.sku),
          variant_id: sanitizeValue(item.variant_id),
          variant_title: sanitizeValue(item.variant_title),
          product_id: sanitizeValue(item.product_id),
          product_title: sanitizeValue(item.product_title) || sanitizeValue(item.title) || 'Product',
          product_type: sanitizeValue(item.product_type),
          vendor: sanitizeValue(item.vendor),
          url: sanitizeValue(item.url),
          image: sanitizeValue(item.image),
          handle: sanitizeValue(item.handle),
          requires_shipping: item.requires_shipping || false,
          taxable: item.taxable || false,
          gift_card: item.gift_card || false
        };
      };

      var selectedVariants = [];
      var selectedPlan = 'plan1';
      
      if (typeof DVTP1K_Swatches !== 'undefined' && DVTP1K_Swatches.selectedVariants) {
        selectedVariants = DVTP1K_Swatches.selectedVariants;
      }
      
      if (typeof DVTP1K_Plans !== 'undefined' && DVTP1K_Plans.selectedPlan) {
        selectedPlan = DVTP1K_Plans.selectedPlan;
      }

      return {
        token: sanitizeValue(cart.token),
        note: sanitizeValue(cart.note),
        attributes: cart.attributes || {},
        total_price: sanitizeValue(cart.total_price) || 0,
        total_weight: sanitizeValue(cart.total_weight) || 0,
        item_count: sanitizeValue(cart.item_count) || 0,
        items: Array.isArray(cart.items) ? cart.items.map(sanitizeItem) : [],
        requires_shipping: cart.requires_shipping || false,
        currency: sanitizeValue(cart.currency) || 'USD',
        items_subtotal_price: sanitizeValue(cart.items_subtotal_price) || 0,
        original_total_price: sanitizeValue(cart.original_total_price) || 0,
        image: sanitizeValue(cart.image),
        total_discount: sanitizeValue(cart.total_discount) || 0,
        shop_domain: window.location.hostname,
        selected_variants: selectedVariants,
        selected_plan: selectedPlan
      };
    },

    fetchCartData: function() {
      const self = this;
      return fetch(this.getCartJsonUrl())
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Error fetching cart.json');
          }
          return response.json();
        })
        .then(function(cartData) {
          return self.sanitizeCartData(cartData);
        });
    },

    saveCartCookie: function(cartData) {
      try {
        const cartJson = JSON.stringify(cartData);
        const cartBase64 = btoa(unescape(encodeURIComponent(cartJson)));
        
        const expires = new Date();
        expires.setTime(expires.getTime() + (1 * 60 * 60 * 1000));
        
        document.cookie = this.cookieName + '=' + cartBase64 + '; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax';
        
        return cartBase64;
      } catch (error) {
        return null;
      }
    },

    buildCheckoutUrl: function(cartData) {
      if (!cartData) {
        return null;
      }
      
      try {
        const cartJson = JSON.stringify(cartData);
        const cartBase64 = btoa(unescape(encodeURIComponent(cartJson)));
        
        return this.checkoutUrl + '?cart=' + encodeURIComponent(cartBase64);
      } catch (error) {
        return null;
      }
    },

    bindCheckoutButton: function(checkoutBtn) {
      if (!checkoutBtn) return;
      
      checkoutBtn.setAttribute('data-checkout-bound', 'true');
      
      const self = this;
      const originalText = checkoutBtn.textContent;

      checkoutBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        checkoutBtn.disabled = true;
        checkoutBtn.style.opacity = '0.7';
        checkoutBtn.textContent = 'Processing...';
        
        self.fetchCartData()
          .then(function(cartData) {
            if (!cartData) {
              throw new Error('Could not get cart data');
            }

            self.saveCartCookie(cartData);

            const checkoutUrl = self.buildCheckoutUrl(cartData);
            
            if (checkoutUrl) {
              window.location.href = checkoutUrl;
            } else {
              throw new Error('Could not build checkout URL');
            }
          })
          .catch(function(error) {
            alert('Error processing checkout. Please try again.');
            
            checkoutBtn.disabled = false;
            checkoutBtn.style.opacity = '1';
            checkoutBtn.textContent = originalText;
          });
      }, true);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      ExternalCheckout.init();
    });
  } else {
    ExternalCheckout.init();
  }

})();